import { css } from '@emotion/core';
import { rgba, globalTokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var mediaStats = /*#__PURE__*/css("display:flex;flex-direction:row;align-items:center;background:", rgba(11, 32, 71, 0.25), ";color:", globalTokens.colors.white, ";gap:8px;border-radius:3px;position:absolute;right:4px;bottom:4px;");
export var item = {
  name: "4t82a2",
  styles: "display:flex;flex-direction:row;align-items:center;padding:0px 2px;gap:4px;"
};
export var itemIcon = {
  name: "1xna78j",
  styles: ".domain-icon{margin-top:3px;vertical-align:top;width:18px !important;height:18px !important;}"
};
export var itemValue = /*#__PURE__*/css(designTokenFonts.body);